import sliceCreator from '../../index.js';
import {PR_UPDATE_ORDER} from '../../../constants/index.js';
const _prUpdateOrderAction = sliceCreator('PR_UPDATE_ORDER',PR_UPDATE_ORDER, 'put');

const { asyncAction: prUpdateOrderAction, reducer, clearData: clearprUpdateOrderData } = _prUpdateOrderAction;

export default reducer;

export {
    prUpdateOrderAction,
    clearprUpdateOrderData
}


